/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDigitGroupDelimiter;
function getDigitGroupDelimiter(locale) {
  var number = 1000;
  return number.toLocaleString(locale).replace(/[01]/g, '') || ',';
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/NumericInput/src/utils/get-digit-group-delimiter.js
// module id = 737
// module chunks = 0